export { default } from './hui-badges';
export type { HUIBadgesProps } from './types';
